module.exports = __webpack_public_path__ + "static/media/jongseo-park.ad567904.png";